// src/features/preorders/preordersSlice.ts

import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { RootState } from "../../../redux/store";
import axiosInstance from "../../../api/axiosInstance";
import endpoints from "../../../api/endpoints";

interface Preorder {
  NombreArticles: number;
  NumeroCommande: number;
  StatutSolde: string | null;
  StatutLivraison: string | null;
  StatutFacturation: string | null;
  STATUSCOMMANDE: string;
  StatutFinal: string | null;
  NumeroClient: string;
  NumeroRepresentant: string | null;
  DateCommande: string;
  MontantTTC: number;
  IsExistsPyramide: boolean;
  NomClient: string;
  Motif: string | null;
  UpdatedOn: string;
}

interface PreorderState {
  loading: boolean;
  error: string | null;
  preorders: Preorder[];
}

interface UpdateStatusInput {
  statutId: number;
  precommandeId: number;
}

const initialState: PreorderState = {
  loading: false,
  error: null,
  preorders: [],
};


export const fetchPreorders = createAsyncThunk(
  "preorders/fetchPreorders",
  async (_, { getState }) => {
    const state = getState() as RootState;

    const language = state.languageSlice.language;
    
    const response = await axiosInstance.get(
      endpoints.preOrders.precommandeList,
      {
        headers: {
          "Accept-Language": language,
        },
      }
    );    

    return response.data as Preorder[];
  }
);

export const updatePreorderStatus = createAsyncThunk(
  "preorders/updatePreorderStatus",
  async (data: UpdateStatusInput, { getState }) => {
    const state = getState() as RootState;

    const language = state.languageSlice.language;
    
    const response = await axiosInstance.post(
      endpoints.preOrders.updateStatut,
      data,
      {
        headers: {
          "Accept-Language": language,
        },
      }
    );   
    return response.data;
  }
);

const preordersSlice = createSlice({
  name: "preorders",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPreorders.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPreorders.fulfilled, (state, action: PayloadAction<Preorder[]>) => {
        state.loading = false;
        state.preorders = action.payload;
      })
      .addCase(fetchPreorders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch preorders";
      })
      .addCase(updatePreorderStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updatePreorderStatus.fulfilled, (state, action: PayloadAction<number>) => {
        state.loading = false;
      })
      .addCase(updatePreorderStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update preorder status";
      });
  },
});

export default preordersSlice.reducer;
